module.exports = __webpack_public_path__ + "static/media/2.91acdc12.jpg";